import http, {RequestOptions, unwrap} from "@/api/http";
import {PartnerDto, PartnerInput, PartnerOptionDto, PartnerOrderCountsDto, PartnerSummaryDto} from "@/api/types";

export interface ListPartnersParams {
    /** Partner search text. */
    q?: string;
}

/** `GET /api/partners?q=` (#6, admin): the rows of the Partners table, without `partnerDetails`. */
export const listPartners = (params: ListPartnersParams = {}, options?: RequestOptions): Promise<PartnerSummaryDto[]> =>
    http.get<PartnerSummaryDto[]>("/partners", {...options, params}).then(unwrap);

/** `GET /api/partners/options` (#7, admin): `{id, name, externalName}` for the partner selects, sorted by `externalName`. */
export const listPartnerOptions = (options?: RequestOptions): Promise<PartnerOptionDto[]> =>
    http.get<PartnerOptionDto[]>("/partners/options", options).then(unwrap);

/** `GET /api/partners/{id}` (#8, admin) */
export const getPartner = (id: number, options?: RequestOptions): Promise<PartnerDto> =>
    http.get<PartnerDto>(`/partners/${id}`, options).then(unwrap);

/**
 * `POST /api/partners` (#9, admin). 201. Never updates: 409 `PARTNER_NAME_TAKEN` if the name exists. The create form
 * shows that on the name field, so it calls this with `{skipErrorToast: true}`.
 */
export const createPartner = (input: PartnerInput, options?: RequestOptions): Promise<PartnerDto> =>
    http.post<PartnerDto>("/partners", input, options).then(unwrap);

/** `PUT /api/partners/{id}` (#10, admin). Changes to `name` are ignored (it is the Shopify vendor key). */
export const updatePartner = (id: number, input: PartnerInput, options?: RequestOptions): Promise<PartnerDto> =>
    http.put<PartnerDto>(`/partners/${id}`, input, options).then(unwrap);

/** `PUT /api/me/partner` (#11, any user with a partner; 403 `NO_PARTNER` without one). `partnerCharge` and `name` are ignored. */
export const updateMyPartner = (input: PartnerInput, options?: RequestOptions): Promise<PartnerDto> =>
    http.put<PartnerDto>("/me/partner", input, options).then(unwrap);

/** `GET /api/partners/{id}/order-counts?year=` (#12, admin): orders per month of `year`. */
export const getPartnerOrderCounts = (id: number, year: number, options?: RequestOptions): Promise<PartnerOrderCountsDto> =>
    http.get<PartnerOrderCountsDto>(`/partners/${id}/order-counts`, {...options, params: {year}}).then(unwrap);
